import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { ProjectViewModel } from "../../../ViewModel/ProjectViewModel";
import { isDisabledForSpdr } from "./LtlTabTable/IsDisabledForSpdr";
import { isDisabledForPdsr } from "./LtlTabTable/IsDisabledForPdsr";

export function areEveryPipelinesChanged(
  ltlPipelines: Array<LtlPipelineViewModel>,
  stopDataOfSpdrsOrPdsrs: number[],
  project: ProjectViewModel
) {
  const areEveryPipelinesChanged = false;
  const disabledPipelines: boolean[] = [];
  ltlPipelines.forEach((pipeline) => {
    if (pipeline.SpdrId) {
      disabledPipelines.push(
        isDisabledForSpdr(
          pipeline.SpdrId,
          project,
          stopDataOfSpdrsOrPdsrs,
          pipeline
        )
      );
    }

    if (pipeline.PdsrId) {
      disabledPipelines.push(
        isDisabledForPdsr(
          pipeline.PdsrId,
          project,
          stopDataOfSpdrsOrPdsrs,
          pipeline
        )
      );
    }
  });

  return !disabledPipelines.includes(false);
}
